import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Card from 'react-bootstrap/Card'
import { Button, Toast } from 'react-bootstrap'
import '../styles/login.css'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { END_POINT } from '../config'

export default function Login({ setToken }) {
  const [username, setUserName] = useState()
  const [password, setPassword] = useState()
  const [showEmailToast, setEmailToast] = useState(false)
  const [showPasswordToast, setPasswordToast] = useState(false)
  const [showToast, setShowToast] = useState(false)

  const handle_submit = async (e) => {
    e.preventDefault()

    if (!username) {
      setEmailToast(true)
    } else if (!password) {
      setPasswordToast(true)
    } else {
      const response = await fetch(
        `${END_POINT}login_user?username=`+username+'&password='+password,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        },
      )

      const responseMessage = await response.json()
      if (responseMessage && responseMessage.length>0 && responseMessage[0]["name"]){
        setToken([responseMessage[0]]);
      }else{
        setShowToast(true)
      }
      console.log(responseMessage)
    }
  }

  return (
    <div className="">
      <Row>
        <Col xs={6}>
          <Toast
            onClose={() => setEmailToast(false)}
            show={showEmailToast}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <img
                src="holder.js/20x20?text=%20"
                className="rounded me-2"
                alt=""
              />
              <strong className="me-auto">Error</strong>
            </Toast.Header>
            <Toast.Body>Please enter Emailid </Toast.Body>
          </Toast>
          <Toast
            onClose={() => setPasswordToast(false)}
            show={showPasswordToast}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <img
                src="holder.js/20x20?text=%20"
                className="rounded me-2"
                alt=""
              />
              <strong className="me-auto">Error</strong>
            </Toast.Header>
            <Toast.Body>Please enter Password </Toast.Body>
          </Toast>
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <img
                src="holder.js/20x20?text=%20"
                className="rounded me-2"
                alt=""
              />
              <strong className="me-auto">Error</strong>
            </Toast.Header>
            <Toast.Body>UserName or Password is not matching </Toast.Body>
          </Toast>
        </Col>
      </Row>

      <div></div>
      <div className="login-body">
        <form className="form-signin ">
          <h1 className="h3 mb-3 font-weight-normal">Please sign in</h1>
          <label htmlFor="inputEmail" className="sr-only">
            Email address/User Name
          </label>
          <input
            type="email"
            id="inputEmail"
            onChange={(e) => setUserName(e.target.value)}
            className="form-control"
            placeholder="Email address / User Name"
            required
            autoFocus
          />
          <label htmlFor="inputPassword" className="sr-only">
            Password
          </label>
          <input
            type="password"
            id="inputPassword"
            onChange={(e) => setPassword(e.target.value)}
            className="form-control"
            placeholder="Password"
            required
          />
          <div className="checkbox mb-3">
            <label></label>
          </div>
          <button
            className="btn btn-lg btn-primary btn-block"
            type="submit"
            onClick={handle_submit}
          >
            Sign in
          </button>
        </form>
      </div>
    </div>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
}
